import { useEffect, useState, useRef } from 'react'
import { Badge, Container, Row, Col, Form } from 'react-bootstrap'
import DashboardLayout from '../../../layouts/Dashboard'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import styles from './styles.module.css'

import NotificationsBanner from '../../../components/NotificationsBanner'
import { CaretDown, CaretRight, Check, MapPin } from 'phosphor-react'
import { isSmallDevice } from '../../../utils/deviceScreen'
import { DateTime } from 'luxon'

import DeliveryFlowMap from '../../../components/Delivery/DeliveryFlowMap'
import { DeliveryFlow } from '../../../components/Delivery/DeliveryFlow'
import SearchInput from '../../../components/SearchInput'
import RequestModal from '../../../components/RequestModal'

import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../../hooks/LoadingContext'

function MainMap() {
  const { setIsLoading } = useLoading()
  const navigate = useNavigate()

  const [vehicles, setVehicles] = useState()
  const [selectedVehicle, setSelectedVehicle] = useState()
  const [selectedRequest, setSelectedRequest] = useState()

  const [notifications, setNotifications] = useState(null)

  const [hasMoreNotifications, setHasMoreNotifications] = useState(true)
  const [sectionCollapseMap, setSectionCollapseControl] = useState([true, false, false])

  const headerRef = useRef(null)
  const searchRef = useRef('')
  const vehicleActivityRef = useRef(null) // Ref para o container do scroll
  const scrollPositionRef = useRef(0) // Ref para salvar a posição do scroll

  const handleCollapseOpen = (clickedIndex) => {
    const newSectionArray = Array(3).fill(false)
    newSectionArray[clickedIndex] = !sectionCollapseMap[clickedIndex]

    setSectionCollapseControl(newSectionArray)

    //Transição
    setTimeout(() => {
      headerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // Ajusta a posição de destino
        inline: 'nearest', // Controla o alinhamento horizontal
      })
    }, 300)
  }

  async function loadNotifications() {
    try {
      const limit = 11
      setIsLoading(true)
      const { data } = await api.get(
        `/attendant/delivery-reports?limit=${limit}&offset=${notifications?.length}}`,
      )

      if (data.length < limit) {
        setHasMoreNotifications(false)
      }
      setNotifications(notifications.concat(data))
    } catch (err) {
      toast.error('Falha ao buscar os dados! Atualize a página.')
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (hasMoreNotifications && notifications?.length < 90) {
      loadNotifications()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications])

  const handleScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (!sectionCollapseMap[1] || !hasMoreNotifications) return
    if (scrollTop <= scrollHeight - clientHeight - 5) {
      return
    }

    loadNotifications()
  }

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        const { data } = await api.get('/attendant/vehicles')
        setVehicles(data)

        if (selectedVehicle) {
          setSelectedVehicle(data.find((v) => v.id === selectedVehicle.id))
        }
      } catch (err) {
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
      setIsLoading(false)
    }
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsLoading])

  useEffect(() => {
    async function loadDataInterval() {
      try {
        setIsLoading(true)
        const { data } = await api.get('/attendant/vehicles')

        setVehicles(data)
        if (selectedVehicle) {
          setSelectedVehicle(data.find((v) => v.id === selectedVehicle.id))
        }
      } catch (err) {
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
      setIsLoading(false)
    }
    let interval = setInterval(() => {
      loadDataInterval()
    }, 30000)

    return () => {
      clearInterval(interval)
    }
  }, [setIsLoading, selectedVehicle])

  useEffect(() => {
    async function loadNotifications() {
      try {
        setIsLoading(true)
        const { data } = await api.get(`/attendant/delivery-reports?limit=100`)

        if (data.length < 100) {
          setHasMoreNotifications(false)
        }

        setNotifications(data.concat(notifications ? notifications : []))
      } catch (err) {
        toast.error('Falha ao buscar os dados! Atualize a página.')
      }
      setIsLoading(false)
    }
    loadNotifications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsLoading])

  useEffect(() => {
    const interval = setInterval(async () => {
      let apiUrl = `/attendant/delivery-reports?limit=${notifications?.length}`

      const { data } = await api.get(apiUrl)
      if (JSON.stringify(data) !== JSON.stringify(notifications)) {
        setNotifications(data)
      }
    }, 35000)

    return () => clearInterval(interval)
  }, [notifications, setIsLoading])

  /* Date must be a ISO string. Returns a date distance from now. */
  function getDateDistanceFromNow(date) {
    const dateDistance = DateTime.fromISO(date).toRelative({ locale: 'pt-BR' })
    return dateDistance
  }

  // Função para salvar a posição do scroll da seção de Atividade dos veículos
  const saveScrollPosition = () => {
    if (vehicleActivityRef.current) {
      setTimeout(() => {
        scrollPositionRef.current = vehicleActivityRef.current.scrollTop
      }, 50)
    }
  }

  useEffect(() => {
    const restoreScrollPosition = () => {
      if (vehicleActivityRef.current) {
        vehicleActivityRef.current.scrollTop = scrollPositionRef.current
      }
    }
    restoreScrollPosition()
  }, [vehicles])

  const handleRequestSelected = async (request) => {
    //busca informacoes mais completas a respeito da request em questao do backend
    let apiUrl = `/attendant/requests/delivery?status=allocated,on_route,delivered,canceled&search=${request.invoice}&limit=1`
    try {
      const { data } = await api.get(apiUrl)
      if (data.length) setSelectedRequest(data[0])
    } catch (e) {
      setSelectedRequest(request) //se nao conseguiu informacoes mais completas, seta apenas com o que já tinha
    }
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" className="ml-5 mr-5" pageName="Início">
      <div style={{ color: '#A59E9E' }}>
        <Row className={styles.searchContainer}>
          <SearchInput
            className="m-0 p-0"
            placeholder="Digite o nome do cliente, nº do pedido/nota, código fiscal, placa do veículo ou nome do motorista"
            searchValue={''}
            setValue={(value) => {
              searchRef.current = value
            }}
            handleSearch={() =>
              navigate(`/atendente/entregas?predefinedSearch=${searchRef.current}`)
            }
            showOptions={false}
          />
        </Row>
      </div>
      {
        <span
          ref={headerRef}
          className={styles.notificationHeader}
          onClick={() => handleCollapseOpen(0)}
        >
          {isSmallDevice() ? (
            <p style={{ marginBottom: 0, marginLeft: 15 }}>Atividade dos veículos</p>
          ) : (
            <p style={{ marginBottom: 0 }}>Atividade dos veículos</p>
          )}
          {sectionCollapseMap[0] ? (
            <CaretDown color="#000000" weight="bold" />
          ) : (
            <CaretRight color="#000000" weight="bold" />
          )}
        </span>
      }

      {sectionCollapseMap[0] && vehicles && vehicles.length && (
        <Container
          fluid
          className={styles.vehicleactivityDiv}
          ref={vehicleActivityRef}
          onScroll={saveScrollPosition}
        >
          {vehicles.map((vehicle, index) => {
            return (
              <div key={`vehicledeliveryflow_${index}`} className={styles.vehicleactivityContainer}>
                <p className={`${styles.vehicleactivityHeader} text-left px-0 px-md-1`}>
                  <button
                    className={styles.mapButton}
                    title="Abrir mapa do veículo"
                    onClick={() => {
                      handleCollapseOpen(2)
                      setSelectedVehicle(vehicle)
                    }}
                  >
                    <MapPin size={14} weight="fill" />
                  </button>
                  {`${vehicle.model} ${vehicle.color ? vehicle.color.toLowerCase() : ''} | Placa ${vehicle.board} - `}
                  <span style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {`Última atualização ${getDateDistanceFromNow(vehicle.updated_at)}`}
                  </span>
                </p>
                <div className="px-1 px-md-3">
                  <DeliveryFlow
                    onRequestSelect={handleRequestSelected}
                    role="attendant"
                    showBorder={true}
                    vehicleId={vehicle.id}
                  />
                </div>
              </div>
            )
          })}
        </Container>
      )}

      <span className={styles.notificationHeader} onClick={() => handleCollapseOpen(1)}>
        {isSmallDevice() ? (
          <p style={{ marginBottom: 0, marginLeft: 15 }}>Notificações</p>
        ) : (
          <p style={{ marginBottom: 0 }}>Notificações</p>
        )}
        {sectionCollapseMap[1] ? (
          <CaretDown color="#000000" weight="bold" />
        ) : (
          <CaretRight color="#000000" weight="bold" />
        )}
      </span>

      {sectionCollapseMap[1] && (
        <div className={styles.notificationsContainer}>
          {notifications && notifications.length > 0 ? (
            <NotificationsBanner
              role="attendant"
              notifications={notifications}
              setNotifications={(notifications) => setNotifications(notifications)}
              handleScroll={(values) => handleScroll(values)}
            />
          ) : (
            <div style={{ width: '100%', padding: 25, display: 'flex', justifyContent: 'center' }}>
              <Badge bg="success" text="light" style={{ textAlign: 'center', width: '80%' }}>
                <Check style={{ marginBottom: 1 }} color="#FFFFFF" size={15} weight="bold" /> Todas
                as notificações foram lidas!
              </Badge>
            </div>
          )}
        </div>
      )}

      <span
        className={styles.notificationHeader}
        onClick={() => {
          if (sectionCollapseMap[2]) setSelectedVehicle(undefined)
          handleCollapseOpen(2)
        }}
      >
        {isSmallDevice() ? (
          <p style={{ marginBottom: 0, marginLeft: 15 }}>Mapa dos veículos</p>
        ) : (
          <p style={{ marginBottom: 0 }}>Mapa dos veículos</p>
        )}
        {sectionCollapseMap[2] ? (
          <CaretDown color="#000000" weight="bold" />
        ) : (
          <CaretRight color="#000000" weight="bold" />
        )}
      </span>

      {sectionCollapseMap[2] && (
        <Row className="d-flex align-items-center justify-content-center">
          <Col xs={7}>
            <Form.Select
              className={styles.vehicleSelect}
              onChange={(e) => {
                let index = e.target.value
                setSelectedVehicle(vehicles[index])
              }}
            >
              <option value={-1}>Selecione o veículo</option>
              {vehicles?.map((vehicle, index) => (
                <option key={`selectvehicle_${index}`} value={index}>
                  {`${vehicle.model} ${vehicle.color ? vehicle.color.toLowerCase() : ''} | Placa ${vehicle.board}`}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      )}

      {sectionCollapseMap[2] && selectedVehicle && (
        <DeliveryFlowMap vehicle={selectedVehicle} role="attendant" />
      )}

      {selectedRequest && (
        <RequestModal
          request={selectedRequest}
          userRole="attendant"
          showEditButton={false}
          showRequestModal={selectedRequest}
          setShowRequestModal={() => setSelectedRequest(undefined)}
        ></RequestModal>
      )}
    </DashboardLayout>
  )
}

export default MainMap
